/**
 * useDynamicBackground - Custom hook for dynamic SVG background generation
 * Reuses existing svgUtils functionality while providing a cleaner API
 */

import { useState, useEffect } from 'react';
import { createSvgUrl } from '../utils/svgUtils';

export const useDynamicBackground = (svgTemplates, fillColor1, fillColor2) => {
  const [backgroundImage, setBackgroundImage] = useState('');

  useEffect(() => {
    if (!svgTemplates || !fillColor1 || !fillColor2) {
      return;
    }

    const generateBackground = async () => {
      try {
        const svgUrl1 = createSvgUrl(svgTemplates.bottom1, fillColor1);
        const svgUrl2 = createSvgUrl(svgTemplates.bottom2, fillColor2);
        
        setBackgroundImage(`url(${svgUrl2}), url(${svgUrl1})`);
      } catch (error) {
        console.warn('Failed to generate background:', error);
        setBackgroundImage('');
      }
    };

    generateBackground();
  }, [svgTemplates, fillColor1, fillColor2]);

  return backgroundImage;
};
